const STORAGE_KEY = `proto:favorites:${window.Shopify?.shop || window.location.hostname}`;

function loadFavorites() {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(value) ? value.map(String) : [];
  } catch {
    return [];
  }
}

function saveFavorites(ids) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
}

function isFavorited(productId, favorites) {
  return favorites.includes(String(productId));
}

function syncButtons() {
  const favorites = loadFavorites();
  document.querySelectorAll('[data-proto-favorite-btn][data-product-id]').forEach((button) => {
    const productId = button.getAttribute('data-product-id');
    if (!productId) return;
    const active = isFavorited(productId, favorites);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-label', active ? 'Remove from saved' : 'Save product');
  });
}

function toggleFavorite(productId) {
  const id = String(productId);
  const favorites = loadFavorites();
  const next = favorites.includes(id)
    ? favorites.filter((item) => item !== id)
    : [...favorites, id];
  saveFavorites(next);
  syncButtons();
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-proto-favorite-btn][data-product-id]');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const productId = button.getAttribute('data-product-id');
  if (!productId) return;
  toggleFavorite(productId);
});

let rafId = null;
const observer = new MutationObserver(() => {
  if (rafId) return;
  rafId = window.requestAnimationFrame(() => {
    rafId = null;
    syncButtons();
  });
});

observer.observe(document.documentElement, { childList: true, subtree: true });

document.addEventListener('DOMContentLoaded', syncButtons);
window.addEventListener('pageshow', syncButtons);
syncButtons();
